import React from 'react'
import { Translations } from '../../../shared/i18n/Translations'

interface Props {
    expectedReportCount: number
    isExpanded: boolean
    rootClassName?: React.HTMLAttributes<HTMLDivElement>['className']
    toggleExpansion: () => void
}

export function ReportHistoryExpandingButton(props: React.PropsWithChildren<Props>) {
    if (props.expectedReportCount === 0) return null

    const chevronDirection = props.isExpanded ? 'down' : 'right'

    return (
        <div className={props.rootClassName}>
            <button
                className="AppCore__ReportHistory__button"
                onClick={props.toggleExpansion}
                aria-expanded={props.isExpanded}
            >
                <zaptic-rotating-chevron direction={chevronDirection} />
                <span className="AppCore__ReportHistory__button-text">
                    {Translations.t('appcore:common.history')}{' '}
                    <span className="AppCore__ReportHistory__button-count">({props.expectedReportCount})</span>
                </span>
            </button>
            {props.isExpanded && props.children}
        </div>
    )
}
